.researchMarkdown {
  white-space: normal;

  :global([data-markdown]) {
    ul,
    ol {
      margin: 0.5em 0 1em;
      padding-left: 1.2em;
    }

    li {
      margin: 0.25em 0;
      padding-left: 0;
    }
  }

  :global([data-markdown] li) .paragraph {
    margin-bottom: 0;
  }

  :global([data-markdown]) :global(.notProse) {
    ul,
    ol,
    li {
      list-style: none;
      margin: 0;
      padding: 0;
    }
  }

  :where(&) img {
    height: 32px;
    width: auto;
  }
}

.paragraph:not(:only-child) {
  margin-bottom: 1em;
}
